


import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import {
  Box,
  Breadcrumbs,
  Button,
  Divider,
  Grid,
  Link,
  ListItemIcon,
  Menu,
  MenuItem,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Theme,
  Typography,
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { useDispatch } from 'react-redux';
import { Link as RouteLink, useHistory, useParams } from 'react-router-dom';

import { getAccountAction, useAccount, } from '@ivymobi/orbit-core/business/tenant';
import { getStatsAction, useStats } from '@ivymobi/orbit-core/business/stats';
import { getProductImage, Tenant } from '@ivymobi/orbit-core';
import QuickStart from '../dashboard/quickStart';
import Title from '../components/views/title';
import Menus, { OpenMenuItem } from '../components/views/menuItem';
import { getAllCatalogsAction, getCatlogsAction, getControlsAction, getOptionControlsAction, getProductSelectionCgIDAction, getProductSelectionRobotAction, getRobotLocalesAction, useModelOptions } from '@ivymobi/orbit-core/business/productCenter';
import { filter, isUndefined, union } from 'lodash';
import { DeviceType, WebSiteContext } from '../orbit-context';
import ZTree from './component/zTree';
import './selections.css'
import RobotSearch from './component/robotSearch';
import ProductItem from './component/productItem';
import { Favorite, Share } from '@mui/icons-material';
import { Loading, TabPanel } from '../components';
import { IvymobiTabs } from '../components/IvymobiTabs';
import SelectionItem from './component/selectionItem';
import _ from 'lodash';
import { el } from 'date-fns/locale';
import { modelOptionsAction, useOptions } from '@ivymobi/orbit-core/business/user';
import ControlPanel from './component/controlPanel';
import OptionControlPanel from './component/optionControlPanel';

const useStyles = makeStyles((theme: Theme) => createStyles({
  pages: {
    display: 'flex',
    flexDirection:'column',
    height:'100%',
    alignItems:'center'
  },
  sliderBar:{
    display: 'flex',
    flexDirection:'column',
    width:'25%',
    paddingTop:theme.spacing(2),
    paddingBottom:theme.spacing(2)
  },
  content:{
    flexGrow:1,
    flexBasis:0,
    display:'flex',
    // justifyContent:'center',
    alignItems:'center',
    flexDirection:'column',
    paddingTop:theme.spacing(2),
    paddingBottom:theme.spacing(2)  },


}));
const IDivider = withStyles((theme: Theme) =>
  createStyles({
    vertical:{
      width:'2px'
    }
  }),
)(Divider);
const CustomTabs = withStyles((theme: Theme) => ({
 indicator: {
   display: 'flex',
   justifyContent: 'center',
   backgroundColor: 'transparent',
   '& > span': {
     display:'none',
     maxWidth: 36,
     width: '100%',
     backgroundColor: '#2a74eb',
   },
 },
 flexContainer:{
   alignItems:'center',
   padding:'7px'
 }

}))((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

export const RobotSelectionsView = (props) => {
  const { id } = useParams<any>()??{id:null};
  const deviceType = useContext(DeviceType);

  const classes = useStyles();
  const history = useHistory();
  // const modeOptions = useOptions();
  const [ modeOptions,setMModeOptions] = useState({robot:null,robotOptions:null,control:null,controlOptions:null,robotOptionId:null,controlOptionId:null,controlId:null,robotId:null})
  const {webInfo,language,getUnit} = useContext(WebSiteContext);
  const [showData,setShowData] = useState(null)
  const [selectInfo, setSelectInfo] = useState({show:false, item:null, target:null});
  const [[anchorEl, selectId], setAnchorEl] = useState([null, null]);
  const setModeOptions = (value,message)=>{
    setMModeOptions(value)
  }
  const dispatch = useDispatch();
  const [searchText,setSearchText] = useState('');
  // const [id, setId] = useState(null);
  const [result,setResult] = useState({result:[],onRefresh:false});
  const [value, setValue] = React.useState(0);
  const [flush, setFlush] = React.useState(false);
  const [robots, setRobots] = React.useState([]);
  const [showFilter, setShowFilter] = React.useState({});
  const [filters, setFilters] = React.useState({'IF000001':[],'IF000004':[],'IF000005':[],'IF000007':[]});
	const [filterRobts,setFilterRobots] = useState([])
  const [showFilterResult,setShowFilterResult] = useState(false)

  const [modelList,setModelList] = useState({robot:null,robotOptions:null,control:null,controlOptions:null});
  const [robotSelect,setRobotSelect] = useState(null)
  const [modelListCount,setModelListCount] = useState(0);
  const [controlList,setControlList] = useState([]);
  const [optionList,setOptionList] = useState([]);

  const [cardInfos,setCardInfos] =useState(null)
  const [loading,setLoading] = useState(false);
  const handleChange = (event, newValue) => {
    if(modelListCount==0&&(newValue==2|| newValue==4)){ 
      return;
    }
    setValue(newValue);
  };
  useEffect(()=>{
    props.setTitle('产品选型')
    props.setParents([{ to:'/robot',name:'机器人'}])
  },[])
 useEffect(()=>{
    let count = 0;
    if(modeOptions.robot){
      count++;
    }
    if(modeOptions.robotOptions){
      count = count +modeOptions.robotOptions?.length;
    }
    if(modeOptions.control){
      count++;
    }
    if(modeOptions.controlOptions){
      count = count +modeOptions.controlOptions?.length;
    }
    setModelListCount(count)
  },[modeOptions]);
  useEffect(()=>{
    if(!modeOptions.robot) 
    return;   
    dispatch(getOptionControlsAction({tenantId:webInfo.tnt_id,robotId:modeOptions.robot.id,cgIds:getCgId(cardInfos,'机器人选件')+(modeOptions.control?','+getCgId(cardInfos,'控制器选件')+'':'')})).then((res)=>{
      for(let m=0;m<res.length;m++){
        for(let i=0;i<res[m].productsData.length;i++){
          let featuresDic = {};
          let product = res[m].productsData[i];
          
          const csName = _.get(product,'feature[0].referenceFeatureSystemName')
          const features =  _.get(product,'feature[0].features')
          for(let index=0;index<features.length;index++){
            featuresDic[features[index].frIdref]  ={ftype:features[index].fvalueIdref?'ref':'value', frIdref:features[index].frIdref,fvalue:features[index].fvalueIdref?features[index].fvalueIdref:features[index].fvalue,fvalueName:language[csName].fValues[features[index].fvalueIdref], fIdName:language[csName].features[features[index].frIdref]}
          }
          product.featuresDic = featuresDic;
        }
        
        if(res[m].real_cgId===getCgId(cardInfos,'机器人选件')){
          setModeOptions({...modeOptions,robotOptionId:res[m].id},1)

        }else if(res[m].real_cgId===getCgId(cardInfos,'控制器选件')){
          setModeOptions({...modeOptions,controlOptionId:res[m].id},2)
        }
      }
      
      setOptionList(res)
    }) 
    dispatch(getControlsAction({tenantId:webInfo.tnt_id,robotId:modeOptions.robot.id,cgId:getCgId(cardInfos,'控制器')})).then((res)=>{
    

      for(let i=0;i<res.productsData.length;i++){
        let featuresDic = {};
        let product = res.productsData[i];
        
        const csName = _.get(product,'feature[0].referenceFeatureSystemName')
        const features =  _.get(product,'feature[0].features')
        for(let index=0;index<features.length;index++){
          featuresDic[features[index].frIdref]  ={ftype:features[index].fvalueIdref?'ref':'value', frIdref:features[index].frIdref,fvalue:features[index].fvalueIdref?features[index].fvalueIdref:features[index].fvalue,fvalueName:language[csName].fValues[features[index].fvalueIdref], fIdName:language[csName].features[features[index].frIdref]}
        }
       
        product.featuresDic = featuresDic;
      }
     

      setControlList(res)

    })
    
  },[modeOptions.robot])
  useEffect(()=>{
    if(!modeOptions.robot)
    return;
    dispatch(getOptionControlsAction({tenantId:webInfo.tnt_id,robotId:modeOptions.robot.id,cgIds:getCgId(cardInfos,'机器人选件')+(modeOptions.control?','+getCgId(cardInfos,'控制器选件')+'':''),controlId:modeOptions.controlId})).then((res)=>{
      for(let m=0;m<res.length;m++){
        for(let i=0;i<res[m].productsData.length;i++){
          let featuresDic = {};
          let product = res[m].productsData[i];
          
          const csName = _.get(product,'feature[0].referenceFeatureSystemName')
          const features =  _.get(product,'feature[0].features')
          for(let index=0;index<features.length;index++){
            featuresDic[features[index].frIdref]  ={ftype:features[index].fvalueIdref?'ref':'value', frIdref:features[index].frIdref,fvalue:features[index].fvalueIdref?features[index].fvalueIdref:features[index].fvalue,fvalueName:language[csName].fValues[features[index].fvalueIdref], fIdName:language[csName].features[features[index].frIdref]}
          }
          product.featuresDic = featuresDic;

        }
        if(res[m].real_cgId===getCgId(cardInfos,'机器人选件')){
          setModeOptions({...modeOptions,robotOptionId:res[m].id},3)

        }else if(res[m].real_cgId===getCgId(cardInfos,'控制器选件')){
          setModeOptions({...modeOptions,controlOptionId:res[m].id},4)
        }
      }
      
      setOptionList(res)
    })
  },[modeOptions.control])

  const getCgId =(infos,cgName)=>{
    for(let i=0;i<infos?.length;i++){
      if(infos[i].cgName?.zh===cgName){
        
        return infos[i].cgId;
      }
     
    }
    return ''
  }
  const postModelOptions = (options)=>{
    dispatch(modelOptionsAction({user:{id:'options'}, tenant:{id:webInfo.tnt_id}, options}));
  }
  const ClickItem = (index,item)=>{
    for(let i=0;i<filters[index].length;i++){
      if(item.value===filters[index][i].value){
        _.remove(filters[index],(fil)=>{
          console.log('file=',fil)
          return fil.value===item.value;
        })
        setFlush(!flush)
        return;
      }
    }
    filters[index][0]=(item);
    setFlush(!flush)
  }
    const RequestData = () => {
      if(robots.length>0 || !webInfo.tnt_id)
        return;
        setLoading(true)
      dispatch(getProductSelectionCgIDAction({user:{token:null,user:null}, tenant:{id:webInfo.tnt_id}})).then(
        (infos) => { 
          setCardInfos(infos);
          dispatch(getProductSelectionRobotAction({user:{token:null,user:null}, tenant:{id:webInfo.tnt_id},cgId:getCgId(infos,'机器人')})).then(
            (_rebot) => { 
             
              for(let i=0;i<_rebot.productsData.length;i++){
                let featuresDic = {};
                let product = _rebot.productsData[i];
                
                const csName = _.get(product,'feature[0].referenceFeatureSystemName')
                const features =  _.get(product,'feature[0].features')
                for(let index=0;index<features.length;index++){
                  featuresDic[features[index].frIdref]  ={ftype:features[index].fvalueIdref?'ref':'value', frIdref:features[index].frIdref,fvalue:features[index].fvalueIdref?features[index].fvalueIdref:features[index].fvalue,fvalueName:language[csName].fValues[features[index].fvalueIdref], fIdName:language[csName].features[features[index].frIdref]}
                }
                product.featuresDic = featuresDic;
              }
              setRobots(_rebot.productsData)
              console.log("==========================id",{...modeOptions,robotId:_rebot.id})
              setModeOptions({...modeOptions,robotId:_rebot.id},5)
              setLoading(false)
            }, (e) => { 
            }
          );
        }, (e) => { 
        }
      );

      
      
    };
    const checkIsExist = (values,value)=>{
      for(let i=0;i<values.length;i++){
        if(values[i].value===value){
          return true;
        }
      }
      return false;

    }
  const clearOptionSelect = ()=>{
    for(let m=0;m<optionList.length;m++){
      for(let i=0;i<optionList[m].productsData.length;i++){
        let product = optionList[m].productsData[i];
        product.bSelect = false;
      }
    }
    
    // setOptionList(res)
  }
  useEffect(()=>{
    if(!robots)
      return;
    let  allFilters = {};
    let filterRobots = [];

    for(let i=0;i<robots.length;i++){
      const robot = robots[i];
      const keys = Object.keys(filters);
      let bContinru = true;
      for(let index = 0; index<keys.length; index++){
        if(!filters[keys[index]][0])
          continue;
        if(robot.featuresDic[keys[index]]?.fvalue!=filters[keys[index]][0]?.value){
          bContinru = false;
        }
      }
      if(!bContinru) continue;
      filterRobots.push(robot);
      for(let index = 0; index<keys.length; index++){
        const fils = filters[keys[index]];
        if(!robot.featuresDic[keys[index]])
        continue;
        if(!allFilters[keys[index]]){
          allFilters[keys[index]] = {name:(robot.featuresDic[keys[index]].fIdName),frIdref:robot.featuresDic[keys[index]].frIdref}
        }
        if(!allFilters[keys[index]].values)
          allFilters[keys[index]].values = [];
        if(checkIsExist(allFilters[keys[index]].values,robot.featuresDic[keys[index]].fvalue) )
          continue;

        allFilters[keys[index]].values.push({value:robot.featuresDic[keys[index]].fvalue,valueName:robot.featuresDic[keys[index]].fvalueName})
      } 
    }
    setShowFilter(allFilters);
    let allSelect = true;
    const keys = Object.keys(filters);
    for(let i=0;i<keys.length;i++){
      if((isUndefined(filters[keys[i]]))||filters[keys[i]].length==0 ){
        allSelect = false;
        break;
      }
    }
    setFilterRobots(filterRobots);
    console.log("allSelect==",allSelect)
    setShowFilterResult(allSelect)
    if(!allSelect&& modeOptions.robot){
      setModeOptions({...modeOptions,robot:null,robotOptions:null,control:null,controlOptions:null,robotOptionId:null,controlOptionId:null,controlId:null},modeOptions)

    }
    // setShowFilter()
  },[robots,language,flush])
  useEffect(() => {
    if (!webInfo)
      return;
    RequestData();
   
  }, [webInfo]);
  const handleMenuClose = () => {
    setAnchorEl([null, null]);
  };
  useEffect(() => {
    if (selectInfo.target==null)
      return;
    setAnchorEl([selectInfo.target, selectInfo.item.type==='catalog'?selectInfo.item.cgId:selectInfo.item.details.supplierAltPid]);
  }, [selectInfo]);

  
  return (
    <div style={{height:deviceType==='computer'?'calc(100% - 30px)':'100%'}}>
        <Menu anchorEl={anchorEl} keepMounted
      open={Boolean(anchorEl)} onClose={handleMenuClose} 
    >
      <MenuItem onClick={()=>{setAnchorEl([null, null]);}} dense>
        <ListItemIcon>
          <Share fontSize='small' /> 
        </ListItemIcon>
        <Typography>分享</Typography>
      </MenuItem>
      <MenuItem onClick={()=>{setAnchorEl([null, null]);}} >
        <ListItemIcon>
          <Favorite fontSize='small' />
        </ListItemIcon>
        <Typography>收藏</Typography>
      </MenuItem>
    </Menu>
      {deviceType==='computer'&&<Breadcrumbs style={{height:'30px'}} separator=">" maxItems={3}>
        <Link
        //   key={b.id}
          color='textPrimary'
          to={'/'}
          component={RouteLink}
        >
          首页
        </Link>
        <Link
        //   key={b.id}
          color='textPrimary'
          to={'/robot'}
          component={RouteLink}
        >
          机器人
        </Link>
        <Typography color="textPrimary">
          产品选型
        </Typography>
      </Breadcrumbs>}
      <Box className={classes.pages}>
        <Box style={{width:deviceType==='computer'?'80%':'100%',paddingTop:'18px',paddingBottom:'16px',height:'100%',display:'flex',flexDirection:'column'}}> 
          <Box style={{display:'flex',justifyContent:deviceType==='computer'?'space-between':'flex-end'}}>
           {deviceType==='computer'&& <Title name={'产品选型'}></Title>}
           <Box style={{display:'flex',flexDirection:'row'}}>
            <Box style={{position:'relative',marginRight:'20px'}}>

              <Button variant='contained' color='primary' style={{background:'red',fontSize:'15px'}} onClick={()=>{ postModelOptions(modeOptions);history.push('/robot/selectList')
              }}> 选型清单
              </Button>
              <Box style={{color:'red',display:'flex',justifyContent:'center',alignItems:'center',background:'white',borderRadius:'10px',position:'absolute',right:'-8px',top:'-8px',width:'20px',height:'20px'}}>
                {modelListCount}
              </Box>
            </Box>
            {deviceType==='computer'&&<Button variant='contained' color='primary' style={{ }} onClick={()=>{
              if(value==0){
                setFilters({'IF000001':[],'IF000004':[],'IF000005':[],'IF000007':[]});
                setModeOptions({...modeOptions,robot:null,robotOptions:null,control:null,controlOptions:null,robotOptionId:null,controlOptionId:null,controlId:null},7)
              }
              if(value==2){
                clearOptionSelect()
                setModeOptions({...modeOptions,control:null,controlOptions:null,robotOptions:null},8)
              }else if(value==4){
                clearOptionSelect()
                setModeOptions({...modeOptions,controlOptions:null,robotOptions:null},9)
              }
              setFlush(!flush)
            }} >
               重新选择
            </Button>}
           </Box>
          </Box> 
          <Box sx={{ borderBottom: 1, borderColor: 'divider' ,width:'100%', background:'white', marginTop:'12px'}}>
            <CustomTabs  value={value} onChange={handleChange} aria-label="basic tabs example"  variant="fullWidth">
              <Tab label={modeOptions.robot?"机器人✔":"机器人"} style={{ color:value==0?'red':'black',fontSize:'17px'}} disableRipple id={`simple-tabpanel-${0}`}/>

              <div className='right'>
                <div className='rightcontenant'>

                </div>
              </div>
           
              <Tab label={modeOptions.control&&modeOptions.robot?"控制器✔":"控制器"}    style={{cursor:modelListCount>0?'pointer':'no-drop',color:value==2?'red':'black',fontSize:'17px'}} disableRipple/>
              <IDivider orientation="vertical" flexItem />

              <Tab label={(modeOptions.controlOptions  ||modeOptions.robotOptions) &&modeOptions.robot?"选件✔":"选件"}  style={{cursor:modelListCount>0?'pointer':'no-drop',color:value==4?'red':'black',fontSize:'17px'}} disableRipple/>
            </CustomTabs>
          </Box>
          <Divider/>
          {loading&&<Loading></Loading>}

          <Box style={{width:'100%',flexGrow:1,height:'0px',overflowY:'auto'}}>
            <TabPanel value={value}  id={0} >
              <Box style={{padding:'20px',background:'white'}}>
                <SelectionItem ClickItem={ClickItem}  showFilter={showFilter} filters={filters}></SelectionItem>
                {showFilterResult&&<Box  style={{padding:'10px'}}>
                   <Box style={{fontSize:'17px'}}>
                    选择结果
                  </Box>
                  <Typography style={{fontSize:'12px',opacity:'0.4'}}>选型结果仅供参考</Typography>
                  <TableContainer component={Paper}>
                  <Table stickyHeader style={{width:deviceType==='computer'?'100%':'1034px',overflow:'auto'}}>
                      <TableHead>
                        <TableRow>
                          <TableCell style={{top:'0px',left:'0px',zIndex:1000,position:'sticky',background:'white'}}>系列</TableCell>
                          <TableCell  style={{background:'white'}} align="center">型号</TableCell>
                          <TableCell   style={{background:'white'}} align="center">{`最大可搬运重量(${getUnit('IF000004')})`}</TableCell>
                          <TableCell style={{background:'white'}} align="center">{`臂长(${getUnit('IF000005')})`}</TableCell>
                          <TableCell style={{background:'white'}} align="center">{`上下行程(${getUnit('IF000006')})`}</TableCell>
                          <TableCell style={{background:'white'}} align="center">使用环境</TableCell>
                          <TableCell style={{background:'white'}} align="center">缩略图</TableCell>
                          {deviceType==='computer'&&<TableCell style={{background:'white'}} align="right">操作</TableCell>}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filterRobts.map((row) => (
                          <TableRow key={row.name}>
                             {deviceType==='computer'&&<TableCell style={{top:'0px',left:'0px',zIndex:1000,position:'sticky',background:'white'}} component="td" scope="row">
                              {row.featuresDic['IF000001']?.fvalueName}
                            </TableCell> }
                            {(!modeOptions?.robot || modeOptions.robot.id!=row.id)&&deviceType==='mobile'&&<TableCell style={{top:'0px',left:'0px',zIndex:1000,position:'sticky',background:'white'}}   component="td" scope="row">
                                <Box  style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                                  <Box>{_.get(row,'details.descriptionShort.zh')}</Box>
                                  <Box  onClick={()=>{
                                  setModeOptions({...modeOptions,robot:row},11)
                                 
                                  setRobotSelect(row);
                                }} style={{backgroundColor:'#eaeaea',color:'red',marginTop:'8px',width:'30px',height:'30px',textAlign:'center',display:'flex',justifyContent:'center',alignItems:'center'}}> + </Box>

                                </Box>
                              
                              </TableCell>}
                              {(modeOptions?.robot && modeOptions.robot.id===row.id)&&deviceType==='mobile'&&<TableCell style={{top:'0px',left:'0px',zIndex:1000,position:'sticky',background:'white'}}   component="td" scope="row">
                                <Box  style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                                  <Box>{_.get(row,'details.descriptionShort.zh')}</Box>
                                  <Box  onClick={()=>{
                                  setModeOptions({...modeOptions,robot:null},12)
                                }} style={{backgroundColor:'#eaeaea',color:'red',marginTop:'8px',width:'30px',height:'30px',textAlign:'center',display:'flex',justifyContent:'center',alignItems:'center'}}> ✔  </Box>

                                </Box>
                              
                              </TableCell>}
                           <TableCell style={{background:'white'}}   classes={{stickyHeader:'true'}} align='center'>
                              
                              {_.get(row,'details.descriptionShort.zh')}
                              </TableCell>
                             
                            <TableCell  style={{background:'white'}} align="center">{row.featuresDic['IF000004']?.fvalue+''}</TableCell>
                            <TableCell   style={{background:'white'}} align="center">{row.featuresDic['IF000005']?.fvalue+''}</TableCell>
                            <TableCell  style={{background:'white'}} align="center">{row.featuresDic['IF000006']?.fvalue+''}</TableCell>
                            <TableCell  style={{background:'white'}} align="center">{row.featuresDic['IF000007']?.fvalueName}</TableCell>
                            <TableCell  style={{background:'white'}} align="center"> 
                              <img src={ getProductImage(row?.mime)} style={{width:'45px',height:'45px'}}/>
                            </TableCell>
                            {(!modeOptions?.robot || modeOptions.robot.id!=row.id)&&deviceType==='computer'&& <TableCell align="right"><Button variant='contained' 
                                style={{ background:'#ece8e8',color:'red',width:'150px'}}
                                onClick={()=>{
                                  setModeOptions({...modeOptions,robot:row},11)
                                 
                                  setRobotSelect(row);
                                }}
                              >
                                加入选型清单 +
                              </Button></TableCell>}
                              {(modeOptions?.robot && modeOptions.robot.id===row.id)&&deviceType==='computer'&& <TableCell align="right"><Button variant='contained' 
                                style={{ background:'#ece8e8',color:'red'}}
                                onClick={()=>{
                                  setModeOptions({...modeOptions,robot:null},12)
                                }}
                              >
                                已加入 ✔
                              </Button></TableCell>}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    </TableContainer>
                </Box>
               
              }
              </Box>
              
              
            </TabPanel>
            <TabPanel value={value} id={2}>
              <ControlPanel language={language} data = {controlList} setModeOptions={setModeOptions} modeOptions={modeOptions}></ControlPanel>
            </TabPanel>
            <TabPanel value={value} id={4}>
              <OptionControlPanel cardInfos={cardInfos} getCgId={getCgId} language={language} data = {optionList} setModeOptions={setModeOptions} modeOptions={modeOptions}></OptionControlPanel>
            </TabPanel>
          </Box>
          {deviceType==='mobile'&&<Box style={{display:'flex',alignItems:'center',background:'white',justifyContent:'center'}}>
                <Button variant='contained' color='primary' style={{width:'80%',background:'gray'}} onClick={()=>{
                if(value==0){
                  setFilters({'IF000001':[],'IF000004':[],'IF000005':[],'IF000007':[]});
                  setModeOptions({...modeOptions,robot:null,robotOptions:null,control:null,controlOptions:null,robotOptionId:null,controlOptionId:null,controlId:null},7)
                }
                if(value==2){
                  clearOptionSelect()
                  setModeOptions({...modeOptions,control:null,controlOptions:null,robotOptions:null},8)
                }else if(value==4){
                  clearOptionSelect()
                  setModeOptions({...modeOptions,controlOptions:null,robotOptions:null},9)
                }
                setFlush(!flush)
              }} >
                重新选择
              </Button>
              </Box>}
        </Box>
        

      </Box>
    </div>
  );
};

export default function RobotSelectionsContainer (props) {
  const dispatch = useDispatch();


  return (
    <RobotSelectionsView {...props}

    />
  );
}